"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TimeSeries_1 = __importDefault(require("./TimeSeries"));
class TimeSeriesData {
    constructor({ label, values }) {
        this.toJSON = () => ({
            label: this.label,
            values: this.values,
        });
        this.label = label;
        this.values = values;
    }
}
TimeSeriesData.fromJSON = (json) => {
    const { label, values } = Object.assign({}, json);
    if (typeof label !== 'string')
        throw new Error('.label must be a string');
    if (!Array.isArray(values))
        throw new Error('.values must be an array');
    const _values = values.map(value => TimeSeries_1.default.fromJSON(value));
    return new TimeSeriesData({
        label: label,
        values: _values,
    });
};
exports.default = TimeSeriesData;
